<app-common-header [isAdminOrTutor]="true"></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="users">
      <ng-container *ngIf="!isDataLoading">
        <div class="users__filterMenu">
          <form class="users__filterMenu--filters" [formGroup]="form">
            <mat-form-field class="small-field">
              <mat-label>Role</mat-label>
              <mat-select formControlName="roleId" class="capitalize">
                <mat-option [value]="0">Select All</mat-option>
                <mat-option
                  class="capitalize"
                  *ngFor="let role of roles"
                  [value]="role.roleId"
                >
                  {{ role.roleName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="small-field">
              <mat-label>Status</mat-label>
              <mat-select formControlName="userStatusId">
                <mat-option [value]="-1">Select All</mat-option>
                <mat-option [value]="0">Not Verified</mat-option>
                <mat-option [value]="1">Initiated</mat-option>
                <mat-option [value]="2">Ready to Approve</mat-option>
                <mat-option [value]="3">Approved</mat-option>
                <mat-option [value]="4">Blocked</mat-option>
              </mat-select>
            </mat-form-field>

            <input placeholder="" formControlName="searchText" />
            <mat-checkbox formControlName="searchInChilds" class="child-filter">
              Filter by Child
            </mat-checkbox>
            <button
              mat-raised-button
              class="button-field"
              (click)="applyAllFilters()"
            >
              Search
            </button>

            <div class="users__buttonStack">
              <button
                class="textButton users__buttonStack__addStudent"
                [routerLink]="['/create-student']"
              >
                <mat-icon>add_circle</mat-icon>Create Student
              </button>
            </div>
          </form>
        </div>
      </ng-container>
      <table
        mat-table
        [dataSource]="users"
        *ngIf="role === '1'"
        class="users__table"
      >
        <ng-container matColumnDef="first_name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td
            mat-cell
            *matCellDef="let user"
            class="capitalize"
            data-label="Name"
          >
            <!-- <a [routerLink]="['/user-details/' + user.user_id]">{{
              user.first_name + " " + user.last_name
            }}</a> -->
            <a
              (click)="openUserDetails(user.user_id)"
              class="users__table__name"
              >{{ user.first_name + " " + user.last_name }}</a
            >
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-mail</th>
          <td
            mat-cell
            *matCellDef="let user"
            data-label="Email"
            [ngClass]="!user.email ? 'faded' : ''"
          >
            {{ user.email ? user.email : "NA" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef>Gender</th>
          <td
            mat-cell
            *matCellDef="let user"
            data-label="Gender"
            [ngClass]="
              user.gender !== 1 && user.gender !== 2 && user.gender !== 3
                ? 'faded'
                : ''
            "
          >
            {{
              user.gender === 1
                ? "Male"
                : user.gender === 2
                ? "Female"
                : user.gender === 3
                ? "Other"
                : "NA"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="role_id">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td
            mat-cell
            *matCellDef="let user; let i = index"
            data-label="Role"
            [ngClass]="
              user.role_id !== 1 &&
              user.role_id !== 2 &&
              user.role_id !== 3 &&
              user.role_id !== 4
                ? 'faded'
                : ''
            "
          >
            <!-- <p *ngIf="editArray.indexOf(i) < 0">
          {{
            user.role_id === 1
              ? "Admin"
              : user.role_id === 2
              ? "Tutor"
              : user.role_id === 3
              ? "Student"
              : user.role_id === 4
              ? "Parent"
              : "NA"
          }}
        </p> -->
            <select
              class="users__table__select"
              (change)="changeInitiated(user.user_id)"
              [(ngModel)]="user.role_id"
              [disabled]="user.user_status === 1"
            >
              <!-- <option value="1">Admin</option>
          <option value="2">Tutor</option>
          <option value="3">Student</option>
          <option value="4">Parent</option> -->
              <option *ngFor="let role of roles" [value]="role.roleId">
                {{ role.roleName }}
              </option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="registration_request_note">
          <th mat-header-cell *matHeaderCellDef>Notes</th>
          <td mat-cell *matCellDef="let user" data-label="Notes">
            {{ user.registration_request_note }}
          </td>
        </ng-container>
        <ng-container matColumnDef="user_status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td
            mat-cell
            *matCellDef="let user; let i = index"
            data-label="Status"
          >
            <!-- <p *ngIf="editArray.indexOf(i) < 0">
          {{
            user.user_status === 1
              ? "Initiated"
              : user.user_status === 2
              ? "Ready to Approve"
              : user.user_status === 3
              ? "Approved"
              : user.user_status === 4
              ? "Blocked"
              : "NA"
          }}
        </p> -->
            <select
              class="users__table__select"
              (change)="changeInitiated(user.user_id)"
              [(ngModel)]="user.user_status"
              [disabled]="user.user_status <= 1"
            >
              <option value="0" disabled>Not Verified</option>
              <option value="1" disabled>Initiated</option>
              <option value="2" disabled>Ready to Approve</option>
              <option value="3">Approved</option>
              <option value="4">Blocked</option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td
            mat-cell
            *matCellDef="let user; let i = index"
            data-label="Actions"
          >
            <div class="users__table__buttonStack">
              <!-- <button
            (click)="editFunction(i)"
            *ngIf="editArray.indexOf(i) < 0"
            [disabled]="user.user_status === 1"
            class="button"
          >
            Edit
          </button> -->
              <button
                (click)="saveUserData(user.user_id)"
                class="button users__table__buttonStack--update"
                [disabled]="
                  editArray.indexOf(user.user_id) < 0 ||
                  updateArray.indexOf(user.user_id) >= 0
                "
              >
                Update
              </button>
              <!-- <button
            (click)="cancelEdit(i)"
            class="button"
            *ngIf="editArray.indexOf(i) >= 0"
          >
            Cancel
          </button> -->
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
      </table>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<p-dialog
  [(visible)]="showDetails"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="userId = null"
>
  <app-user-details
    [userId]="userId"
    *ngIf="userId !== null"
  ></app-user-details>
</p-dialog>
